var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOverlayVisible)?_c('div',{staticClass:"ui-overlay",class:{'off-navbar':_vm.isLayoutAsideHidden},on:{"click":_vm.click}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }